<div class="page-title-area">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="page-title-text">
          <h2>CONFIRMATION DE VÉRIFICATION DE L'EMAIL</h2>
          <ul>
            <li><a routerLink="/">ACCUEIL</a></li>
            <li><i class="icofont-simple-right"></i></li>
            <li>CONFIRMATION DE VÉRIFICATION DE L'EMAIL</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="post-job-area pt-100 pb-170">
  <div class="container text-left">
    <img src="assets/img/success.png" alt="" width="170" />
    <div class="pt-5">
      <h4>Votre demande de qualification a bien été enregistrée</h4>
      <p class="mb-4">
        Votre compte a été créé avec succès ! Vous pouvez maintenant vous
        connecter pour accéder à votre espace entreprise.
      </p>
      <p class="mb-4">
        <strong>Important :</strong> Veuillez cliquer sur le bouton "Se
        connecter" pour accéder à votre tableau de bord.
      </p>
      <div class="mt-4 d-flex gap-3">
        <a routerLink="/login-as-company" class="btn btn-primary">
          <i class="icofont-login"></i> Se connecter
        </a>
        <a routerLink="/" class="btn btn-outline-secondary">
          <i class="icofont-home"></i> Retour à l'accueil
        </a>
      </div>
    </div>
  </div>
</div>
